import withContextConsumer from '../withContextConsumer';
import { SettingsConsumer } from './settingsContext';

import { ISettings } from '../../../lib/settings/types';

const withSettings = withContextConsumer<ISettings>(
  SettingsConsumer,
  (settings) => ({
    settings,
  }),
);

interface IWithSettingsProps {
  settings: ISettings;
}

export { IWithSettingsProps };
export default withSettings;
